import { FC } from "react";

import { BaseColumnProps } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";
import { Custom } from "./Custom";

export interface TelephoneProps extends Omit<BaseColumnProps, "align"> {
  /**
   * Optional custom formatter for the telephone value.
   */
  readonly formatter?: (value: string) => string;
}

function defaultTelephoneFormatter(value: string): string {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");
  // Format as XXX-XXX-XXXX
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return value;
}

export const Telephone: FC<TelephoneProps> = (props) => {
  const { formatter } = props;
  return (
    <Custom {...props}>
      {(value) => {
        if (value === null || typeof value === "undefined") return "--";
        const stringValue = String(value);
        return formatter ? formatter(stringValue) : defaultTelephoneFormatter(stringValue);
      }}
    </Custom>
  );
};

(Telephone as ColumnElementConstructor<TelephoneProps>).className = "telephone";
(Telephone as ColumnElementConstructor<TelephoneProps>).headerAlignment = "left";
